import { render } from "./toDoListCard.vue?vue&type=template&id=3e622183&ts=true"
import script from "./toDoListCard.vue?vue&type=script&lang=ts"
export * from "./toDoListCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__